<template>
  <label class="param-button d-block">
    <input
      :name="name"
      :value="value"
      :checked="checked"
      type="radio"
      class="param-button__input"
      :class="classNotSelected"
      @change="selectParam"
    />
    <span class="param-button__wrapper btn border-radius-md" :class="className">
      <slot name="param"></slot>
    </span>
    <slot name="message"></slot>
  </label>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";

export default {
  name: "ParamButton",
  data() {
    return {
      classNotSelected: "",
    };
  },
  props: {
    className: {
      type: String,
      default: "",
    },
    checked: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    object: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup() {
    const store = useProductStore();

    return {
      store,
    };
  },
  mounted() {
    document.addEventListener("check-selected-params", () => {
      if (!this.store.isSelected[this.name]) {
        this.classNotSelected = "param-button__input--no-selected";
      }
    });

    document.addEventListener("clear-selected-params", () => {
      this.classNotSelected = "";
    });
  },
  methods: {
    selectParam(element) {
      document.dispatchEvent(new Event("clear-selected-params"));
      document.dispatchEvent(new Event("hidden-error-no-selected"));

      let name = element.target.name.replace("_availability", "");
      if (name === "size") {
        this.store.setSize(element.target.value);
      } else {
        this.store.selectProperty(name, this.object);
      }
    },
  },
};
</script>
